export const TipoLink = {
  EMBEDDED: { id: 1, nome: 'Embed', codigoInterno: 'embedded' },
  EXTERNO: { id: 2, nome: 'Link externo', codigoInterno: 'externo' }
}

export const TipoLinkUtil = {

  obterPorCodigoInterno: codigoInterno => {
    const key = Object.keys(TipoLink).find(item => TipoLink[item].codigoInterno === codigoInterno)
    if (key) {
      return TipoLink[key]
    }
    return {}
  }
}

export default TipoLink
